import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { Tab } from '@shared';

@Component({
  selector: 'app-reports',
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
})
export class AdminComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  tabs = [
    new Tab('Categories', 'category', true),
    new Tab('Items', 'item', false),
    new Tab('Tasks', 'tasks', false),
    new Tab('Restaurants', 'restaurants', false),
  ];

  ngOnInit() {
    const currentRoute =
      this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
    const selectedTab = this.tabs.find(
      (tab) => tab.contentUrl === currentRoute,
    );
    if (selectedTab) {
      this.selectTab(selectedTab);
    }
  }

  selectTab(selectedTab: Tab) {
    this.tabs.forEach((tab) => {
      tab.selected = tab.name === selectedTab.name;
    });

    this.router.navigate([selectedTab?.contentUrl], {
      relativeTo: this.activatedRoute,
    });
  }

  onTabSelect(event: SelectEvent) {
    const selectedTab = this.tabs.find((tab) => tab.name === event?.title);
    if (selectedTab) this.selectTab(selectedTab);
  }
}
